export default "__VITE_ASSET__CcIb397a__"